export const REDUCER_NAME="bannerSlice";

export interface iBannerRespone {
    bannerId: string;
    vendorId: string;
    product: string;
    bannerType: string;
    bannerUrl: string;
    resoureType: string; 
    status: number;
    created_at: string;
    updated_at: string; 
    resourceType: string;
    images:iBannerImages[]
  }

export interface iBannerImages{
  title:string;
  description:string;
  image:string


}
  export interface iBannerDTO {
    product?: string;
    bannerType?: string;
    bannerUrl?: string;
    resoureType?: string; 
    resourceType?: string;
    image?: File | string;
  }
  

  export interface iBannerState {
      bannerDetail: iBannerRespone | null;
      bannerList:iBannerRespone[]
      isLoading: boolean;
      errorMessage: string | null;
      wholesalerBanner:iBannerRespone[];
      wholesalerBannerById:iBannerRespone[]

  }